module.exports = __webpack_public_path__ + "img/prizeBtn.3dcec528.png";